import { useMutation, UseMutationOptions } from "@tanstack/react-query"

import { httpClient } from "~/backend/axios.ts"
import { queryClient } from "~/backend/queryClient.ts"

export const useDeleteContactMutation = (
  contactId: number,
  options?: UseMutationOptions<void, unknown>
) => {
  return useMutation({
    ...options,
    mutationFn: async () => {
      await httpClient.delete(`/contacts/${contactId}`)
    },
    onSuccess: (data, variables, context) => {
      options?.onSuccess?.(data, variables, context)
      queryClient.invalidateQueries(["listContacts"])
    },
  })
}
